import blocks from './blocks/blocks';

const transformers = [blocks];

export default transformers;
